module.exports = __webpack_public_path__ + "static/media/binnen_slaapkamer_oost.baed233d.jpg";